import React, { useState } from 'react';
import { Modal} from 'react-bootstrap';
import '../styles/FloatingButton.css';
import ContactUsSection from './ContactUsSection';

const FloatingButton = () => {
  const [showModal, setShowModal] = useState(false);

  const handleOpen = () => setShowModal(true);
  const handleClose = () => setShowModal(false);

  

  return (
    <>
      {/* Floating Button */}
      <div className="floating-button" onClick={handleOpen}>
        LET'S CONNECT
      </div>

      {/* Modal */}
      <Modal show={showModal} onHide={handleClose} fullscreen>
        <Modal.Header closeButton>
          <h1>Leave a Message</h1>
        </Modal.Header>
        <Modal.Body>
          <ContactUsSection/>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default FloatingButton;
